<style>
  :host {
    display: block;
    width: 100%;
    min-width: 0;
  }

  .updox-contacts-scroll {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .updox-contacts {
    min-width: 600px;
  }

  /* Prevent long addresses from breaking the flex layout */
  .media-body {
    flex: 1 1 auto;
    min-width: 0;
  }

  .media-body .text-muted {
    overflow-wrap: anywhere;
  }

  .media-right {
    flex: 0 0 auto;
  }

  @media (max-width: 767px) {
    .filters-sec .col-sm-6 {
      width: 100%;
      margin-bottom: 10px;
      text-align: left;
    }

    .panel-body .col-sm-6 {
      width: 100%;
    }
  }
</style>

<div class="updox-contacts-scroll">
  <div class="updox-contacts p" >

  <div class="filters-sec flex-header mb">
    <div class="row">
      <div class="col-sm-6">
        <div class="input-group input-group-sm">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input type="text" class="form-control" placeholder="Search contacts..." [(ngModel)]="searchTerm" />
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <button type="button" class="btn btn-secondary btn-sm" (click)="openAddForm()" *ngIf="!showForm">
          <i class="fa fa-plus mr-sm"></i>Add Contact
        </button>
      </div>
    </div>
  </div>

  <!-- Add / Edit Contact Form -->
  <div class="panel panel-default mb" *ngIf="showForm">
    <div class="panel-heading">
      <strong>{{ isEditing ? 'Edit Contact' : 'New Contact' }}</strong>
      <a class="pull-right" (click)="cancelForm()"><i class="fa fa-times"></i></a>
    </div>
    <div class="panel-body">
      <form #contactForm="ngForm" (ngSubmit)="saveContact()">
        <div class="row">
          <div class="col-sm-6 form-group">
            <label class="field-label">Name <span class="text-danger">*</span></label>
            <input class="form-control" type="text" name="name"
                   [(ngModel)]="formContact.name" required />
          </div>
          <div class="col-sm-6 form-group">
            <label class="field-label">Direct Address <span class="text-danger">*</span></label>
            <input class="form-control" type="email" name="direct_address"
                   [(ngModel)]="formContact.direct_address" required />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 form-group">
            <label class="field-label">Organization</label>
            <input class="form-control" type="text" name="organization"
                   [(ngModel)]="formContact.organization" />
          </div>
          <div class="col-sm-6 form-group">
            <label class="field-label">Specialty</label>
            <input class="form-control" type="text" name="specialty"
                   [(ngModel)]="formContact.specialty" />
          </div>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-default btn-outline mr-sm" (click)="cancelForm()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="!contactForm.form.valid || isSaving">
            <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isSaving"></i>
            {{ isSaving ? 'Saving...' : (isEditing ? 'Update Contact' : 'Save Contact') }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="text-center text-muted p">
    <i class="fa fa-spinner fa-spin mr-sm"></i> Loading contacts...
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && filteredContacts.length === 0 && !showForm" class="text-center text-muted p-xl">
    <i class="fa fa-address-book-o fs30 d-block mb-sm"></i>
    <span *ngIf="contacts.length === 0">No contacts yet. Add one above.</span>
    <span *ngIf="contacts.length > 0">No contacts match "{{ searchTerm }}".</span>
  </div>

  <!-- Contacts list -->
  <ul class="list-unstyled border-list m0" *ngIf="!isLoading && filteredContacts.length > 0">
    <li class="list" *ngFor="let contact of filteredContacts">
      <div class="media" style="display:flex;">
        <div class="media-left">
          <span class="updox-avatar">{{ contact.initial }}</span>
        </div>
        <div class="media-body">
          <div class="fw-500">{{ contact.name }}</div>
          <div class="text-muted fs12">{{ contact.direct_address }}</div>
          <div class="text-muted fs12" *ngIf="contact.organization">
            {{ contact.organization }}<span *ngIf="contact.specialty"> · {{ contact.specialty }}</span>
          </div>
        </div>
        <div class="media-right" style="display:flex; gap:3px; align-items: flex-start;">
          <a class="btn btn-default btn-outline btn-sm mr-xs" title="Send message"
             (click)="composeToContact.emit(contact)">
            <i class="fa fa-envelope-o"></i>
          </a>
          <a class="btn btn-default btn-outline btn-sm mr-xs" title="Edit contact"
             (click)="openEditForm(contact)">
            <i class="fa fa-pencil"></i>
          </a>
          <a class="btn btn-danger btn-outline btn-sm" title="Remove contact"
             (click)="deleteContact(contact)">
            <i class="fa fa-trash-o"></i>
          </a>
        </div>
      </div>
    </li>
  </ul>
</div>
  </div>

